export default __webpack_public_path__ + "static/media/sample_1.ae453c68.png";